import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicRecordListComponent } from './basic-record-list.component';
import { LoadingIndicatorModule } from '../../loading-indicator/loading-indicator.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { RecordListModule } from '../record-list/record-list.module';
import { HasClaimModule } from 'src/app/directives/has-claim/has-claim.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    HasClaimModule,
    LoadingIndicatorModule,
    RecordListModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    BasicRecordListComponent
  ],
  exports: [
    BasicRecordListComponent
  ]
})
export class BasicRecordListModule { }
